<template>
  <!-- Accordion row -->
  <div>
    <h5 class="vue-title">
      <strong>{{ $t("PARENTSELECTION") }}</strong>
    </h5>
    <br />
    <!-- Grid column -->
    <div>
      <!--Accordion wrapper-->
      <div
        class="accordion md-accordion accordion-2"
        id="accordionEx7"
        role="tablist"
        aria-multiselectable="true"
      >
        <!-- Accordion card -->
        <div class="card">
          <!-- Card header -->
          <div
            class="card-header rgba-stylish-strong z-depth-1 mb-1"
            role="tab"
            id="heading1"
          >
            
            <h5 class="mb-0 white-text text-uppercase font-thin">
              <span class="formTextSizeBlack"></span>
              <span class="formTextSize14">{{ this.createPartner.name }}</span>
            </h5>
          </div>

          <!-- Card body -->
          <div
            id="collapseHeadder"
            role="tabpanel"
            aria-labelledby="heading1"
            data-parent="#accordionEx7"
          >
            <div class="card-body mb-1 rgba-grey-light white-text table-responsive">
            <!-- Quessataionary list -->
              <table class="table">
                <thead class="thead-light">
                  <tr>
                    <th id="userID" colspan="3" class="formTextSizeBlack">
                      ID #{{ this.createPartner.userid }}
                    </th>
                    <th id="test"></th>
                  </tr>
                  <tr>
                    <td>
                      <strong class="formTextSizeBlack">担当者:</strong>
                      <br />
                      <span class="formTextSize14">{{
                        this.createPartner.person_in_charge
                      }}</span>
                    </td>
                    <td>
                      <strong class="formTextSizeBlack">電話番号:</strong>
                      <br />
                      <span class="formTextSize14">{{
                        this.createPartner.contact_no
                      }}</span>
                    </td>
                    <td>
                      <strong class="formTextSizeBlack">FAX:</strong>
                      <br />
                      <span class="formTextSize14">{{
                        this.createPartner.fax
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <em class="fa fa-envelope" aria-hidden="true"></em>
                      <br />
                      <span class="formTextSize14">{{
                        this.createPartner.email
                      }}</span>
                    </td>
                    <td>
                      <strong class="formTextSizeBlack">住所:</strong>
                      <br />
                      <span class="formTextSize14"
                        >{{ this.createPartner.prefecture }}
                        {{ this.createPartner.address.city }}</span
                      >
                    </td>
                    <td>
                      <strong class="formTextSizeBlack">ステータス :</strong>
                      <br />
                      <b-form-checkbox
                        v-model.trim="$v.createPartnerStatus.status.$model"
                        name="check-button"
                        switch
                        disabled
                      ></b-form-checkbox>
                    </td>
                    <td></td>
                  </tr>
                </thead>
              </table>
              <b-modal
                id="modal-Status"
                hide-footer
                ref="vuemodal"
                @hidden="close"
              >
                <template v-slot:modal-title>{{
                  $t("STATUSCHANGECONFIRMATION")
                }}</template>
                <p>{{ $t("CHANGESTATUSCONFIRMATION") }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      class="buttons-align-right"
                      @click="StatusChange()"
                      >{{ $t("SUBMIT") }}</b-button
                    >
                    <b-button
                      variant="outline-secondary"
                      class="buttons-align-right"
                      size="sm"
                      @click="close"
                      >{{ $t("CANCEL") }}</b-button
                    >
                  </b-col>
                </b-row>
              </b-modal>
            </div>
          </div>
        </div>

        <!-- Accordion card -->
      </div>
      <!--/.Accordion wrapper-->
    </div>
    <div>
      <br />
      
      <br />
     
      <!--/.Accordion wrapper-->
    </div>
    <!-- Grid column -->
  </div>
  <!-- Accordion row -->
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
<script>
import { mapGetters } from "vuex";
import {
  GET_SERVICE_PARTNER,
  PARTNER_SERVICE_LIST,
  UPDATE_SERVICE_PARTNER,
  GET_PARTNER_BRNACH_LIST
} from "@/store/actions.type";
import { required } from "vuelidate/lib/validators";
export default {
  name: "add-partner",
  components: {},

  data: function() {
    return {
      isToggled: "",
      editOffset: -1,
      editPost: {},
      editPostOri: {},
      createPartnerStatus: {
        status: true
      },
      createPartner: {}
    };
  },
  validations: {
    createPartnerStatus: {
      status: { required }
    }
  },
  methods: {
    /**
     * Show Status Change Modal
     * Input @param {object} row Seleted Row to Change status of it
     * Output PopUp the Status Change Modal
     */
    update() {
      this.$bvModal.show("modal-Status");
    },
    /**
     * Status function for table Row
     * Input 1,@param {Number} userID  selected Row ID 2,@param {string} status  (Active or Inactive)
     * Output @param {boolean}   data.status  status of the api call (true or false)
     */
    StatusChange() {
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
      let selectedItemId = _.get(this.selectedItemForDelete, "id", 0);
      this.$bvModal.hide("modal-Status");
      this.params = this.$route.params;

      if (this.params.id) {
        let status = _.get(this.createPartnerStatus, "status", "");
        this.$store
          .dispatch(UPDATE_SERVICE_PARTNER, {
            id: this.params.id,
            status: status == false ? "inactive" : "active"
          })
          .then(data => {
            this.isLoading.hide();
            if (data.status) {
              this.$toast.success({
                message: data.message
              });
            } else {
              this.$toast.error({
                message: data.message
              });
            }
          });
      } else {
        this.$bvModal.hide("modal-Status");
        this.isLoading.hide();
      }
    }
  },
  computed: {
    ...mapGetters(["partnerBranchList"])
  },
  created() {
    this.params = this.$route.params;
    if (_.get(this.params, "id", 0)) {
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });

      this.$store
        .dispatch(GET_SERVICE_PARTNER, {
          id: _.get(this.params, "id", 0)
        })
        .then(data => {
          this.isLoading.hide();

          if (_.get(data, "status", 0)) {
           
            let partnerObj = _.get(data, "partner");
            let fileds = _.get(partnerObj, "fields", "[]");
            this.list2 = JSON.parse(fileds);
            this.createPartner = partnerObj;
            this.createPartnerStatus["status"] =
              _.get(partnerObj, "status", "") == "active" ? true : false;
          }
        });
    }
  }
};
</script>
<style>
.dragArea {
  min-height: 100px;
  background: #ededed;
  padding: 10px;
}
.list-group-item {
  margin-bottom: 6px;
}
.customLabel {
  font-weight: bold;
}

.accordion > .card:first-of-type {
  border-bottom: 1px solid #e3e6f0 !important;
}
.card-header {
  padding: 0.5rem 1.25rem !important;
}
</style>
